import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Router from './Router/Router';
import './App.css'
import { CartProvider } from './Helper/CartContext';
import { SnackbarProvider } from './Helper/SnackBar';
import { syncAuthTokenFromCookie } from './Helper/authToken';

export default function App() {
  useEffect(() => {
    const handleVisibilitySync = () => {
      if (document.visibilityState === 'visible') {
        syncAuthTokenFromCookie();
      }
    };

    window.addEventListener('focus', syncAuthTokenFromCookie);
    document.addEventListener('visibilitychange', handleVisibilitySync);

    return () => {
      window.removeEventListener('focus', syncAuthTokenFromCookie);
      document.removeEventListener('visibilitychange', handleVisibilitySync);
    };
  }, []);

  return (
    <div className="App">
      <CartProvider>
        <SnackbarProvider>
          <Router/>
        </SnackbarProvider>
     </CartProvider>
    </div>
  );
}

